import { computed, onMounted, ref, watch } from 'vue';
import { unrefElement, useMutationObserver, useScroll } from '@vueuse/core';

export function useScrollShadows (scrollableElement) {
    const { arrivedState } = useScroll(scrollableElement);
    const canScroll = ref(false);
    const hasScrolled = computed(() => !arrivedState.top);

    const checkScroll = async () => {
        const $el = unrefElement(scrollableElement);

        if ($el) {
            const { scrollHeight, clientHeight, scrollTop } = $el;
            canScroll.value = scrollHeight > clientHeight + scrollTop;
        }
    };

    watch(
        () => arrivedState.bottom,
        (arrivedStateBottom) => {
            canScroll.value = !arrivedStateBottom;
        },
    );
    useMutationObserver(scrollableElement, checkScroll, { childList: true, subtree: true });
    onMounted(checkScroll);

    return {
        canScroll,
        hasScrolled,
    };
}
